import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  inject,
  signal,
  viewChild,
} from "@angular/core"
import { GradeComponent } from "./grade.component"
import { GradeModalComponent } from "./grade-modal.component"
import { IntroService } from "../intro.service"
import { distinctUntilChanged, fromEvent, map, shareReplay, startWith } from "rxjs"
import { UiInheritDirective } from "ui-inherit"

@Component({
  imports: [
    GradeComponent,
    GradeModalComponent,
    UiInheritDirective,
  ],
  standalone: true,
  template: `
    <div 
      #gradesElementBegin 
      class="column-center gap-0 border-l-8 border-dashed border-primary-content"
    >
      <div 
        class="row-center gap-0 w-11/12 tablet:w-1/2"
      >
        <e2e-grade 
          [grade]="grades()[0]"
          [aspectRatio]="2"
          inherit
        />
        <e2e-grade 
          [grade]="grades()[1]" 
          [aspectRatio]="2"
          inherit
        />
      </div>
      <div
        class="row-center gap-0 w-11/12 tablet:w-1/2"
      >
        <e2e-grade
          [grade]="grades()[2]"
          [aspectRatio]="1.15"
          inherit
        />
        <e2e-grade 
          [grade]="grades()[3]" 
          [aspectRatio]="1.15"
          inherit
        />
      </div>
    </div>

    <e2e-grade-modal inherit/>
  `,
  selector: "e2e-grades",
})
export class GradesComponent {
  private introService = inject(IntroService)

  // private elementRef_begin = viewChild.required<ElementRef<HTMLElement>>("gradesElementBegin")
  // private nativeElement_begin = computed(() => this.elementRef_begin().nativeElement)

  // scrollPosition = signal(0)
  // windowHeight = signal(0)
  // elementTop = signal(0)
  // elementBottom = signal(0)
  // elementHeight = signal(0)

  // visiblePortion = computed(() => this.scrollPosition() + this.windowHeight() - this.elementTop())
  // visiblePercent = computed(() => {
  //   return Math.max(0, this.visiblePortion() / this.elementHeight())
  // })

  grades = this.introService.grades

/*
  ngAfterViewInit() {
    fromEvent(window, "scroll")
      .pipe(
        map((x) => window.scrollY),
        startWith(0),
        distinctUntilChanged(),
        shareReplay(1),
      )
      .subscribe((scroll) => {
        // console.log("scroll", scroll)
        // console.log("window height", window.innerHeight)

        this.scrollPosition.set(scroll)
        this.windowHeight.set(window.innerHeight)
        this.elementTop.set(this.nativeElement_begin().offsetTop + 50)
        this.elementBottom.set(this.nativeElement_begin().offsetTop + 50 + this.nativeElement_begin().offsetHeight)
        this.elementHeight.set(this.nativeElement_begin().offsetHeight)

        // console.log("begin offsetTop", this.elementTop())
        // console.log("end offsetTop", this.elementBottom())
        // console.log("height", this.elementHeight())
        // console.log(this.visiblePortion())
        // console.log(this.visiblePercent())
      })
  }
*/
}
